import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import itemService from '../../services/item.service'
import { AddonName } from '../../apis/addon.api'
import { ItemData } from '../../apis/item.api'
import subscriberApi, {
  SubscriberSearchItemByCodeRequest
} from '../../apis/subscriber.api'
import SearchPicker, {
  SearchPickerOption
} from '../../components/SearchPicker'
import categoryApi, { CategoryData } from "../../apis/category.api";
import categoryService from "../../services/category.service";

interface MetaCreateAttributableInputProps {
  addon: AddonName
  subscriber: number
  value: string
  onChange: (
    attributable: string,
    attributableId?: number,
  ) => void
}

interface MetaCreateAttributableInputState {
  itemId: number | null
  items: ItemData[]
  categories: CategoryData[]
  categoryId: number | null
  categoryName: String | null
}

export default class MetaCreateAttributableInput extends Component
  <MetaCreateAttributableInputProps, MetaCreateAttributableInputState> {
  constructor (props: MetaCreateAttributableInputProps) {
    super(props)
    this.state = {
      itemId: null,
      items: [],
      categories: [],
      categoryId: null,
      categoryName: null
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleItemSearch = this.handleItemSearch.bind(this)
    this.handleItemSelect = this.handleItemSelect.bind(this)

    this.handleCategorySearch = this.handleCategorySearch.bind(this)
    //this.handleCategoryInputChange = this.handleCategoryInputChange.bind(this)
    this.handleCategorySelect = this.handleCategorySelect.bind(this)
  }

  get itemSearchPicker () {
    return <SearchPicker
      name="attributable"
      value={this.props.value}
      options={this.itemSearchOptions}
      label={i18n("Item")}
      onSearch={this.handleItemSearch}
      onChange={this.handleInputChange}
      onSelect={this.handleItemSelect} />
  }

  get categorySearchPicker () {
    return <SearchPicker
      name="attributable"
      value={this.props.value}
      options={this.categorySearchOptions}
      label={i18n("Category Name")}
      onSearch={this.handleCategorySearch}
      //onChange={this.handleCategoryInputChange}
      onChange={this.handleInputChange}
      onSelect={this.handleCategorySelect} />
  }

  get attributableInput () {
    switch (this.props.addon) {
      case 'extendInventoryCreateFormWhenItemEquals':
        return this.itemSearchPicker
      case 'extendInventoryCreateFormWithQuantityOnCase':
        return this.itemSearchPicker
      case 'extendInventoryCreateFormWithActualWeight':
        return this.itemSearchPicker
      case 'extendInventoryCreateFormWhenCategoryNameEquals':
        return this.categorySearchPicker
      default:
        return null
    }
  }

  // ============ Item
  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  itemSearch (code: string) {
    if (!code) {
      this.setState({ items: [] })
      return
    }
    const params: SubscriberSearchItemByCodeRequest = {
      id: Number(this.props.subscriber),
      code
    }
    subscriberApi.searchItemByCode(params, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'attributable') this.props.onChange(value)
  }

  handleItemSearch (name: string, term: string) {
    this.itemSearch(term)
  }

  handleItemSelect (name: string, option: SearchPickerOption) {
    const itemId = option.id as number
    const item = itemService.find(this.state.items, itemId)
    if (item) {
      this.props.onChange(item.code, itemId)
      this.setState({ itemId, items: [] })
    }
  }
// ============ Item  


// =========== Category
  get categorySearchOptions () {
    return categoryService.searchOptions(this.state.categories)
  }

  categorySearch (term: string) {
    if (!term) {
      this.setState({ categories: [] })
      return
    }
    
    categoryApi.adminSearch(term, categories => {
      if (!categories) return
      this.setState({ categories })
    })
  }

  handleCategorySearch (name: string, value: string) {
    this.categorySearch(value)
  }

  // handleCategoryInputChange (name: string, value: string) {
  //   if (name === 'attributable') this.props.onChange(value)
  // }

  handleCategorySelect (name: string, option: SearchPickerOption) {
    const categoryId = option.id as number
    const category = categoryService.find(this.state.categories, categoryId)
    if (category) {
      this.props.onChange(category.name, categoryId)
      this.setState({ categoryId: categoryId, categories: [], categoryName: category.name })
    }
  }
// ========== Category



  render () {
    return this.attributableInput
  }
}
